module.exports = __webpack_public_path__ + "static/img/icon-num41.4f8724d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icon-num41.png
// module id = 86Oy
// module chunks = 94